// import * as Sentry from "@sentry/react";
import {
  browserTracingIntegration,
  replayIntegration,
  init,
  feedbackIntegration
} from "@sentry/react";

export function initSentry() {
  init({
    enabled: !import.meta.env.DEV,
    dsn: "https://d092df8243dc16d54df118347789bb35@o4506863532179456.ingest.us.sentry.io/4506863714566144",
    integrations: [
      browserTracingIntegration(),
      replayIntegration({
        maskAllText: false,
        blockAllMedia: false
      }),
      feedbackIntegration({
        autoInject: false
      })
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
